import axios from "axios";
import { getSessionToken } from "@shopify/app-bridge-utils";
import createApp from "@shopify/app-bridge";

const shopifyApp = createApp({
    apiKey: window.SHOPIFY_API_KEY,
    shopOrigin: window.SHOPIFY_ORIGIN_SHOP
});

const httpClient = axios.create();
// intercept all requests on this axios instance
httpClient.interceptors.request.use(function (config) {
    return getSessionToken(shopifyApp) // requires an App Bridge instance
        .then((token) => {
            // append your request headers with an authenticated token
            config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        });
});
// export your axios instance to use within your app
export default httpClient;
